import { Component, OnInit } from '@angular/core';
import { MyUtils } from 'src/app/services/my-utils.service';

@Component({
  selector: 'app-not-element-found',
  templateUrl: './not-element-found.component.html',
  styleUrls: ['./not-element-found.component.css']
})
export class NotElementFoundComponent implements OnInit {

  constructor(public utils: MyUtils) { }

  ngOnInit() {
  }

}
